import React from 'react';
import { FiCheck, FiUsers, FiDollarSign, FiFlag, FiActivity } from 'react-icons/fi';

interface ProjectActivityTabProps {
  projectActivities: any[];
}

export const ProjectActivityTab: React.FC<ProjectActivityTabProps> = ({ projectActivities }) => {
  const getActConfig = (type: string) => {
    switch (type) {
      case 'task':
        return {
          icon: <FiCheck className="w-3.5 h-3.5 text-emerald-450" />,
          bg: 'bg-emerald-500/10 border-emerald-500/20',
        };
      case 'invite':
        return {
          icon: <FiUsers className="w-3.5 h-3.5 text-blue-400" />,
          bg: 'bg-blue-500/10 border-blue-500/20',
        };
      case 'budget':
        return {
          icon: <FiDollarSign className="w-3.5 h-3.5 text-amber-400" />,
          bg: 'bg-amber-500/10 border-amber-500/20',
        };
      case 'milestone':
        return {
          icon: <FiFlag className="w-3.5 h-3.5 text-blue-400" />,
          bg: 'bg-blue-500/10 border-blue-500/20',
        };
      case 'create':
      default:
        return {
          icon: <FiActivity className="w-3.5 h-3.5 text-zinc-400" />,
          bg: 'bg-zinc-800 border-white/5',
        };
    }
  };

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      {/* Vertical timeline of activity logs */}
      <div className="relative space-y-6">
        {projectActivities.map((act, index) => {
          const config = getActConfig(act.type);

          return (
            <div key={act.id} className="relative flex items-center gap-4">
              {/* Timeline Line Segments */}
              <div className="absolute left-[18px] top-0 bottom-0 w-[1px] flex flex-col items-center">
                {/* Top Line Segment */}
                <div className={`w-[1px] h-1/2 bg-zinc-800/80 ${index === 0 ? 'opacity-0' : ''}`} />
                {/* Bottom Line Segment */}
                <div
                  className={`w-[1px] h-1/2 bg-zinc-800/80 ${index === projectActivities.length - 1 ? 'opacity-0' : ''}`}
                />
              </div>

              {/* Badge Icon on timeline */}
              <div className="relative z-10 w-9 h-9 rounded-full bg-[#0B0B0B] flex items-center justify-center shrink-0">
                <div
                  className={`w-full h-full rounded-full border flex items-center justify-center ${config.bg}`}
                >
                  {config.icon}
                </div>
              </div>

              {/* Log text card */}
              <div className="flex-1 bg-[#0F0F0F] border border-white/5 rounded-2xl px-5 py-4 flex flex-col justify-center min-h-[72px]">
                <p className="text-zinc-355 text-xs sm:text-sm">
                  <span className="text-white font-bold">{act.user}</span> {act.action}
                </p>
                <span className="text-zinc-550 text-[10px] font-semibold mt-1">
                  {act.timestamp}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
